import React from 'react';

const CtaSection = ({ sectionClassName, sectionId, title, description, buttonClassName, buttonLabel, onClick }) => (
    <section id={sectionId} className={sectionClassName}>
        <div className="container">
            <h2>{title}</h2>
            <p>{description}</p>
            <button type="button" className={buttonClassName} onClick={onClick}>
                {buttonLabel}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    </section>
);

export default CtaSection;
